module.exports = __webpack_public_path__ + "img/malfunction-indicator-unavailable.4374f438.svg";